import React, { useState, useEffect } from 'react'
import axios from 'axios'
import Grid from '@mui/material/Grid2'
import ToggleButton from '@mui/material/ToggleButton'
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup'
import TournamentFace from './HomeCard/TournamentFace'

import {
  isOnline,
  clearTable,
  getData,
  getAllData,
  upsertDataTournaments,
} from '../api/indexedDBHandler'
import { Container, Box, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'

const TournamentsList = () => {
  const [loading, setLoading] = useState(false)
  const [mainStage, setMainStage] = useState(<></>)

  const [archive, setArchive] = useState([])
  const [tournaments, setTournaments] = useState([])
  const [alignmentToggleTypeTournaments, setAlignmentToggleTypeTournaments] =
    useState('tournaments')

  const navigate = useNavigate()
  const openTournamentData = (data) => {
    navigate('/tournaments/' + data.id)
  }
  useEffect(() => {
    setLoading(true)
    if (isOnline()) {
      try {
        const getTournaments = async () => {
          const results = await getData('user', 'created', true)
          const { value } = results[0]
          const response = await axios.post(
            'https://admin-protocarp.ru/php/tournaments/getAll.php',
            {
              ...value,
            }
          )
          if (response.data.success) {
            setLoading(false)
            setTournaments(response.data.tournaments)
            setArchive(response.data.archive)
            if (response.data.archive.length > 0) {
              upsertDataTournaments('archive', response.data.archive)
            }
            if (response.data.tournaments.length > 0) {
              upsertDataTournaments('tournaments', response.data.tournaments)
            }
          } else if (response.data.error_code == 404) {
            setLoading(false)
            setTournaments([])
            setArchive([])
            await clearTable('user')
            // setError("Требуется авторизация");
            // setIsUserName(false);
            // localStorage.removeItem("user");
          } else {
            setLoading(false)
            setArchive([])
            setTournaments([])
          }
        }

        getTournaments()
      } catch (err) {
        alert(
          'Отсутствует соединение с интернетом. Данные взяты из памяти устройства.'
        )
        const getTournaments = async () => {
          const archivesawait = await getAllData('archive')
          setArchive(archivesawait)
          const tournamentsawait = await getAllData('tournaments')
          setTournaments(tournamentsawait)

          setLoading(false)
        }
        getTournaments()
        // setError(err.message);
        // setLoading(false);
      }
    } else {
      alert(
        'Отсутствует соединение с интернетом. Данные взяты из памяти устройства.'
      )
      const getTournaments = async () => {
        const tournamentsawait = await getAllData('tournaments')
        setTournaments(tournamentsawait)
        const archivesawait = await getAllData('archive')
        setArchive(archivesawait)
        setLoading(false)
      }
      getTournaments()
    }
  }, [])

  useEffect(() => {
    setLoading(true)
    if (isOnline()) {
      tournaments.map((tournament) => {
        const getTournamentTeams = async () => {
          const results = await getData('user', 'created', true)
          const { key, value } = results[0]
          const user = {
            id: tournament.id,
            token: value.token,
            phone: value.phone,
          }
          const response = await axios.post(
            'https://admin-protocarp.ru/php/teams/getTeamsIdTournamentForBD.php',
            {
              ...user,
            }
          )
          if (response.data.success) {
            upsertDataTournaments('teams', response.data.teams)
            // const teamsArray = Object.values(response.data.teams)
          } else if (response.data.error_code == 404) {
          }
        }
        getTournamentTeams()
      })
    }
  }, [tournaments])
  const handleChangeaTypeTournaments = (event, newAlignment) => {
    setAlignmentToggleTypeTournaments(newAlignment)
  }
  return (
    <Container sx={{ mb: 15 }}>
      <Box mt={1} display="flex" flexDirection="column" alignItems="center">
        {tournaments.length === 0 && archive.length === 0 ? (
          <Typography variant="body1">У вас нет турниров.</Typography>
        ) : (
          <>
            <ToggleButtonGroup
              color="primary"
              size="small"
              value={alignmentToggleTypeTournaments}
              exclusive
              onChange={handleChangeaTypeTournaments}
              aria-label="Platform"
            >
              <ToggleButton size="small" value="tournaments">
                Активные турниры
              </ToggleButton>
              <ToggleButton size="small" value="archive">
                Архив
              </ToggleButton>
            </ToggleButtonGroup>

            {alignmentToggleTypeTournaments === 'tournaments' ? (
              tournaments.length === 0 ? (
                <Typography variant="body1">Список турниров пуст.</Typography>
              ) : (
                <Grid
                  container
                  spacing={1}
                  sx={{
                    width: '100%',
                  }}
                >
                  {tournaments.map((tournament) => (
                    <Grid
                      key={tournament.id + '34'}
                      mt={2}
                      xs={12}
                      sm={12}
                      md={3}
                      sx={{
                        width: '100%',
                      }}
                    >
                      <TournamentFace
                        key={tournament.id}
                        data={tournament}
                        openTournamentData={openTournamentData}
                      />
                    </Grid>
                  ))}
                </Grid>
              )
            ) : alignmentToggleTypeTournaments === 'archive' ? (
              archive.length === 0 ? (
                <Typography variant="body1">Список турниров пуст.</Typography>
              ) : (
                <Grid
                  container
                  spacing={1}
                  sx={{
                    width: '100%',
                  }}
                >
                  {archive.map((tournament) => (
                    <Grid
                      mt={2}
                      xs={12}
                      sm={12}
                      md={3}
                      sx={{
                        width: '100%',
                      }}
                    >
                      <TournamentFace
                        key={tournament.id}
                        data={tournament}
                        openTournamentData={openTournamentData}
                      />
                    </Grid>
                  ))}
                </Grid>
              )
            ) : null}
          </>
        )}
      </Box>
    </Container>
  )
}

export default TournamentsList
